var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { PatientImportMethod } from "healthex-common/study.dtos";
import { FormModel } from "../FormModel";
import { computed, observable } from "mobx";
import { NamedRoutes } from "../NamedRoutes";
export class AddPatientDataRequestorDialogModel {
    constructor(opts) {
        this.formModel = new FormModel({
            importMethod: null,
        }, ["importMethod"]);
        this.currentView = "HOW_TO_ADD_PATIENTS";
        this.studiesUIManager = opts.container.studiesUIManager;
        this.routingUIManager = opts.container.routingUIManager;
    }
    get study() {
        return this.studiesUIManager.studyToManage;
    }
    get nextButtonEnabled() {
        return this.formModel.input.importMethod !== null;
    }
    get dialogTitle() {
        return this.currentView === "HOW_TO_ADD_PATIENTS"
            ? "How do you want to add patients?"
            : "Share patient experience with QR code or link";
    }
    get dialogSubtitle() {
        return this.currentView === "HOW_TO_ADD_PATIENTS" ? "Select from the options below." : undefined;
    }
    resetForm() {
        this.formModel.input.importMethod = null;
        this.currentView = "HOW_TO_ADD_PATIENTS";
    }
    goToNextStep() {
        var _a;
        const projectId = (_a = this.routingUIManager.currentRouteParams) === null || _a === void 0 ? void 0 : _a.projectId;
        if (!projectId) {
            console.error("No projectId found in route parameters");
            return;
        }
        if (this.formModel.input.importMethod === PatientImportMethod.MANUAL) {
            this.routingUIManager.navigateTo(NamedRoutes.PROJECTS_ADD_PATIENTS_METHOD, {
                projectId,
                method: PatientImportMethod.MANUAL.toLowerCase(),
            });
        }
        else if (this.formModel.input.importMethod === PatientImportMethod.FILE) {
            this.routingUIManager.navigateTo(NamedRoutes.PROJECTS_ADD_PATIENTS_METHOD, {
                projectId,
                method: PatientImportMethod.FILE.toLowerCase(),
            });
        }
        else if (this.formModel.input.importMethod === PatientImportMethod.QR_CODE) {
            this.currentView = "SHARE_PATIENT_LINK";
        }
    }
    goToPreviousStep() {
        if (this.currentView === "SHARE_PATIENT_LINK") {
            this.currentView = "HOW_TO_ADD_PATIENTS";
        }
    }
    get isStudyUsingIdentifiedData() {
        return this.studiesUIManager.isStudyUsingIdentifiedData;
    }
}
__decorate([
    observable
], AddPatientDataRequestorDialogModel.prototype, "currentView", void 0);
__decorate([
    computed
], AddPatientDataRequestorDialogModel.prototype, "study", null);
__decorate([
    computed
], AddPatientDataRequestorDialogModel.prototype, "nextButtonEnabled", null);
__decorate([
    computed
], AddPatientDataRequestorDialogModel.prototype, "dialogTitle", null);
__decorate([
    computed
], AddPatientDataRequestorDialogModel.prototype, "dialogSubtitle", null);
__decorate([
    computed
], AddPatientDataRequestorDialogModel.prototype, "isStudyUsingIdentifiedData", null);
